import { defineEntity } from './_helpers.js';

export default defineEntity('cookieInventory', {});
